import React, { useContext } from 'react';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import QrCodeMonitor from './QrCodeMonitor';
import { useParams } from 'react-router';
import { useGetPermissions } from 'layouts/customHook';



const QrMonitorSetup = () => {
    const { type } = useParams();//B2B  || B2C
    // const userPermissions = useGetPermissions("");
    const userPermissions = true;
    return userPermissions ? <QrCodeMonitor userPermissions={userPermissions} type={type}/> : <PermisionDenied />
}

export default QrMonitorSetup;


